(() => {
  if (customElements.get('babbled-art-gallery')) return;
  customElements.define('babbled-art-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true; this.index = 0; this.loading = null; this.failedURL = null;
      this.track = this.querySelector('.bag-track');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.status = this.querySelector('.bag-status');
      this.more = this.querySelector('.bag-load');
      this.nextURL = this.more?.dataset.nextPage || '';
      this.total = Number(this.dataset.total) || this.slides.length;
      this.querySelector('.bag-controls').hidden = false;
      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.more?.addEventListener('click', e => {e.preventDefault(); this.loadMore(true);});
      this.track.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault(); this.move(e.key === 'ArrowRight' ? 1 : -1);}
      });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const first = this.slides[0]; if (!first) return;
          const position = this.track.scrollLeft + first.offsetLeft;
          let best = 0, distance = Infinity;
          this.slides.forEach((slide, i) => {const d = Math.abs(slide.offsetLeft - position); if(d < distance){distance = d; best = i;}});
          if (best !== this.index) {this.index = best; this.update();}
          if (best >= this.slides.length - 2 && this.nextURL && this.failedURL !== this.nextURL) this.loadMore();
        });
      }, {passive:true});
      this.update();
    }
    get slides() {return Array.from(this.querySelectorAll('.bag-slide'));}
    update() {
      const slides = this.slides, current = slides[this.index];
      slides.forEach((slide, i) => {slide.inert = i !== this.index; slide.setAttribute('aria-hidden', String(i !== this.index));});
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index >= slides.length - 1 && !this.nextURL;
      this.status.textContent = current ? `${current.dataset.position} of ${this.total} designs` : 'No designs to browse';
      if (this.more) this.more.hidden = !this.nextURL;
    }
    async move(delta) {
      let target = this.index + delta;
      if (target >= this.slides.length && this.nextURL) await this.loadMore();
      target = Math.max(0, Math.min(target, this.slides.length - 1));
      const slides = this.slides; if (!slides[target]) return;
      this.track.scrollTo({left:slides[target].offsetLeft - slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    async loadMore(explicit = false) {
      if (this.loading || !this.nextURL) return this.loading;
      const restoreFocus = explicit && document.activeElement === this.more;
      this.loading = this.fetchNext();
      try {await this.loading;} finally {this.loading = null; this.update(); if(restoreFocus && !this.nextURL) this.track.focus({preventScroll:true});}
    }
    async fetchNext() {
      const error = this.querySelector('.bag-error');
      error.hidden = true; this.setAttribute('aria-busy','true');
      if(this.more) this.more.textContent = 'Loading designs…';
      try {
        const url = new URL(this.nextURL, location.origin);
        if(url.origin !== location.origin) throw new Error('Invalid page origin');
        url.searchParams.set('section_id', this.dataset.section);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if(preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url.href, {credentials:'same-origin'});
        if(!response.ok) throw new Error('Gallery page unavailable');
        const document = new DOMParser().parseFromString(await response.text(),'text/html');
        const incoming = document.getElementById(this.id) || document.querySelector('babbled-art-gallery');
        if(!incoming) throw new Error('Gallery not found');
        this.failedURL = null;
        const known = new Set(this.slides.map(slide => slide.dataset.productId));
        incoming.querySelectorAll('.bag-slide').forEach(slide => {if(!known.has(slide.dataset.productId)){known.add(slide.dataset.productId);this.track.append(slide);}});
        this.total = Number(incoming.dataset.total) || this.total;
        this.nextURL = incoming.querySelector('.bag-load')?.dataset.nextPage || '';
        if(this.more && this.nextURL) this.more.href = this.nextURL;
      } catch(e) {
        this.failedURL = this.nextURL;
        error.textContent = 'More designs could not load. Try Load more designs again, or open the collection link above.';
        error.hidden = false;
      } finally {this.removeAttribute('aria-busy'); if(this.more) this.more.textContent = 'Load more designs';}
    }
  });
})();
